/*
 * /sonar-depth-map — files the map is saved as.
 *
 *   SDMExport.gpx(res, o)     isobaths as tracks (one per depth, a segment per
 *                             line) + holes, humps and drop-offs as waypoints —
 *                             what a Garmin, Lowrance or phone navigator opens
 *   SDMExport.kml(res, o)     the same for Google Earth; with o.overlay the
 *                             depth picture as a GroundOverlay (KMZ)
 *   SDMExport.csv(res)        the cleaned soundings, one row per map cell
 *   SDMExport.geotiff(res)    the depth grid, float32, WGS 84 — for QGIS/GIS
 *
 * o: { name, brand, label(level) → text, feature(kind, f) → text, now }
 * Pure: strings in, strings/bytes out (tests run it in node).
 */
(function (root) {
    'use strict';

    function esc(s) {
        return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function f6(v) { return (Math.round(v * 1e6) / 1e6).toFixed(6); }
    function iso(t) { try { return new Date(t || Date.now()).toISOString().replace(/\.\d{3}Z$/, 'Z'); } catch (_) { return ''; } }

    function features(res) {
        var F = res.features || {}, out = [];
        (F.holes || []).forEach(function (f) { out.push({ kind: 'hole', f: f }); });
        (F.humps || []).forEach(function (f) { out.push({ kind: 'hump', f: f }); });
        (F.drops || []).forEach(function (f) { out.push({ kind: 'drop', f: f }); });
        return out;
    }

    function gpx(res, o) {
        o = o || {};
        var L = [];
        L.push('<?xml version="1.0" encoding="UTF-8"?>');
        L.push('<gpx version="1.1" creator="' + esc((o.brand || 'Timbrica') + ' sonar-depth-map') + '" xmlns="http://www.topografix.com/GPX/1/1">');
        L.push('<metadata><name>' + esc(o.name || 'depth map') + '</name><time>' + iso(o.now) + '</time></metadata>');
        features(res).forEach(function (x) {
            L.push('<wpt lat="' + f6(x.f.lat) + '" lon="' + f6(x.f.lon) + '"><name>' + esc(o.feature ? o.feature(x.kind, x.f) : x.kind) + '</name><sym>' + (x.kind === 'hole' ? 'Fishing Hot Spot Facility' : x.kind === 'hump' ? 'Shoal' : 'Danger Area') + '</sym></wpt>');
        });
        (res.contours || []).forEach(function (c) {
            if (!c.lines.length) return;
            L.push('<trk><name>' + esc(o.label ? o.label(c.level) : c.level + ' m') + '</name>');
            c.lines.forEach(function (a) {
                if (a.length < 4) return;
                var seg = ['<trkseg>'];
                for (var i = 0; i < a.length; i += 2) seg.push('<trkpt lat="' + f6(a[i + 1]) + '" lon="' + f6(a[i]) + '"/>');
                seg.push('</trkseg>');
                L.push(seg.join(''));
            });
            L.push('</trk>');
        });
        L.push('</gpx>');
        return L.join('\n');
    }

    // KML colours are aabbggrr.
    function kmlColor(rgb, a) {
        var h = function (n) { return ('0' + Math.round(n).toString(16)).slice(-2); };
        return h(a == null ? 255 : a) + h(rgb[2]) + h(rgb[1]) + h(rgb[0]);
    }

    function kml(res, o) {
        o = o || {};
        var L = [];
        L.push('<?xml version="1.0" encoding="UTF-8"?>');
        L.push('<kml xmlns="http://www.opengis.net/kml/2.2"><Document>');
        L.push('<name>' + esc(o.name || 'depth map') + '</name>');
        var cs = res.contours || [];
        cs.forEach(function (c, i) {
            var rgb = o.color ? o.color(c.level) : [40, 90, 200];
            L.push('<Style id="iso' + i + '"><LineStyle><color>' + kmlColor(rgb) + '</color><width>' + (Math.abs(c.level % (res.interval * 5)) < 1e-6 ? 3 : 1.6) + '</width></LineStyle></Style>');
        });
        L.push('<Style id="hole"><IconStyle><color>ff2a2ae0</color><scale>0.9</scale><Icon><href>http://maps.google.com/mapfiles/kml/shapes/placemark_circle.png</href></Icon></IconStyle></Style>');
        L.push('<Style id="hump"><IconStyle><color>ff2ab4e0</color><scale>0.9</scale><Icon><href>http://maps.google.com/mapfiles/kml/shapes/placemark_circle.png</href></Icon></IconStyle></Style>');
        L.push('<Style id="drop"><IconStyle><color>ff2a7ae0</color><scale>0.8</scale><Icon><href>http://maps.google.com/mapfiles/kml/shapes/triangle.png</href></Icon></IconStyle></Style>');
        if (o.overlay) {
            var g = res.geo;
            L.push('<GroundOverlay><name>' + esc(o.overlayName || 'depth') + '</name><color>d0ffffff</color><Icon><href>' + esc(o.overlay) + '</href></Icon><LatLonBox>' +
                '<north>' + f6(g.lat0 + g.dLat / 2) + '</north><south>' + f6(g.lat0 - (g.h - 0.5) * g.dLat) + '</south>' +
                '<east>' + f6(g.lon0 + (g.w - 0.5) * g.dLon) + '</east><west>' + f6(g.lon0 - g.dLon / 2) + '</west></LatLonBox></GroundOverlay>');
        }
        L.push('<Folder><name>' + esc(o.contoursName || 'isobaths') + '</name>');
        cs.forEach(function (c, i) {
            if (!c.lines.length) return;
            L.push('<Placemark><name>' + esc(o.label ? o.label(c.level) : c.level + ' m') + '</name><styleUrl>#iso' + i + '</styleUrl><MultiGeometry>');
            c.lines.forEach(function (a) {
                if (a.length < 4) return;
                var co = [];
                for (var k = 0; k < a.length; k += 2) co.push(f6(a[k]) + ',' + f6(a[k + 1]) + ',0');
                L.push('<LineString><tessellate>1</tessellate><coordinates>' + co.join(' ') + '</coordinates></LineString>');
            });
            L.push('</MultiGeometry></Placemark>');
        });
        L.push('</Folder>');
        var fs = features(res);
        if (fs.length) {
            L.push('<Folder><name>' + esc(o.featuresName || 'features') + '</name>');
            fs.forEach(function (x) {
                L.push('<Placemark><name>' + esc(o.feature ? o.feature(x.kind, x.f) : x.kind) + '</name><styleUrl>#' + x.kind + '</styleUrl><Point><coordinates>' + f6(x.f.lon) + ',' + f6(x.f.lat) + ',0</coordinates></Point></Placemark>');
            });
            L.push('</Folder>');
        }
        L.push('</Document></kml>');
        return L.join('\n');
    }

    function csv(res, o) {
        o = o || {};
        var s = res.soundings, L = [o.header || 'latitude,longitude,depth_m,soundings'];
        for (var i = 0; i < s.n; i++) L.push(f6(s.lat[i]) + ',' + f6(s.lon[i]) + ',' + (Math.round(s.depth[i] * 100) / 100) + ',' + s.count[i]);
        return L.join('\r\n') + '\r\n';
    }

    // ── GeoTIFF (little-endian, one float32 band, one strip per row) ───────
    function geotiff(res) {
        var g = res.geo, w = g.w, h = g.h, data = res.depth;
        var tags = [];   // [tag, type, count, valueOrArray]
        // types: 2 ASCII, 3 SHORT, 4 LONG, 12 DOUBLE
        var nodata = 'nan\u0000';
        var pixelScale = [g.dLon, g.dLat, 0];
        // tie point: raster (0,0) is the CORNER of the top-left pixel (PixelIsArea)
        var tie = [0, 0, 0, g.lon0 - g.dLon / 2, g.lat0 + g.dLat / 2, 0];
        var geoKeys = [1, 1, 0, 4, 1024, 0, 1, 2, 1025, 0, 1, 1, 2048, 0, 1, 4326, 2054, 0, 1, 9102];
        var rowBytes = w * 4;
        tags.push([256, 4, 1, w]);            // ImageWidth
        tags.push([257, 4, 1, h]);            // ImageLength
        tags.push([258, 3, 1, 32]);           // BitsPerSample
        tags.push([259, 3, 1, 1]);            // Compression none
        tags.push([262, 3, 1, 1]);            // BlackIsZero
        tags.push([273, 4, h, null]);         // StripOffsets (filled below)
        tags.push([277, 3, 1, 1]);            // SamplesPerPixel
        tags.push([278, 4, 1, 1]);            // RowsPerStrip
        tags.push([279, 4, h, null]);         // StripByteCounts
        tags.push([284, 3, 1, 1]);            // PlanarConfiguration chunky
        tags.push([339, 3, 1, 3]);            // SampleFormat IEEE float
        tags.push([33550, 12, 3, pixelScale]);
        tags.push([33922, 12, 6, tie]);
        tags.push([34735, 3, geoKeys.length, geoKeys]);
        tags.push([42113, 2, nodata.length, nodata]);   // GDAL_NODATA
        var TSIZE = { 2: 1, 3: 2, 4: 4, 12: 8 };
        var ifdOff = 8, nTags = tags.length;
        var ifdSize = 2 + nTags * 12 + 4;
        var extraOff = ifdOff + ifdSize, extra = 0;
        tags.forEach(function (t) { var sz = TSIZE[t[1]] * t[2]; if (sz > 4) { t.off = extraOff + extra; extra += sz + (sz % 2); } });
        var dataOff = extraOff + extra;
        dataOff += (4 - dataOff % 4) % 4;
        var total = dataOff + rowBytes * h;
        var buf = new ArrayBuffer(total), dv = new DataView(buf), u8 = new Uint8Array(buf);
        u8[0] = 0x49; u8[1] = 0x49; dv.setUint16(2, 42, true); dv.setUint32(4, ifdOff, true);
        dv.setUint16(ifdOff, nTags, true);
        var p = ifdOff + 2;
        function writeVals(at, type, vals) {
            for (var i = 0; i < vals.length; i++) {
                if (type === 3) dv.setUint16(at + i * 2, vals[i], true);
                else if (type === 4) dv.setUint32(at + i * 4, vals[i], true);
                else if (type === 12) dv.setFloat64(at + i * 8, vals[i], true);
                else if (type === 2) u8[at + i] = vals.charCodeAt(i);
            }
        }
        tags.forEach(function (t) {
            var tag = t[0], type = t[1], count = t[2], v = t[3];
            if (tag === 273) { v = []; for (var r = 0; r < h; r++) v.push(dataOff + r * rowBytes); }
            if (tag === 279) { v = []; for (var r2 = 0; r2 < h; r2++) v.push(rowBytes); }
            dv.setUint16(p, tag, true); dv.setUint16(p + 2, type, true); dv.setUint32(p + 4, count, true);
            var arr = Array.isArray(v) ? v : (typeof v === 'string' ? v : [v]);
            if (t.off != null) { dv.setUint32(p + 8, t.off, true); writeVals(t.off, type, arr); }
            else writeVals(p + 8, type, arr);
            p += 12;
        });
        dv.setUint32(p, 0, true);
        for (var r3 = 0; r3 < h; r3++) {
            for (var c = 0; c < w; c++) dv.setFloat32(dataOff + r3 * rowBytes + c * 4, data[r3 * w + c], true);
        }
        return new Uint8Array(buf);
    }

    var API = { gpx: gpx, kml: kml, csv: csv, geotiff: geotiff, _esc: esc };
    root.SDMExport = API;
    if (typeof module !== 'undefined' && module.exports) module.exports = API;
})(typeof self !== 'undefined' ? self : globalThis);
